
export const nonNull = (value: number | boolean | string) => (value !== null && value !== undefined);
export const isNeighbourhoodId = (id: string) => id.startsWith('שכונה');
